jQuery(document).ready(function($){
  $(window).scroll(function(){
  	var $window = $(this).scrollTop();
    var $head_height = $('header').height();
    
    if ( $window > $head_height ) {
      $('#shopify-section-header').addClass('scroll');
      $('#shopify-section-header').css({
        'height' : $head_height + 'px'
      });
    } else {
      $('#shopify-section-header').removeClass('scroll');
      $('#shopify-section-header').css({
        'height' : 'auto'
      });
    }
  });
  
  var item_count;
  
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'json',
    success: function(data) { 
      item_count = data.item_count;
      $('.site-header__cart-indicator').text(item_count);
    }
  });
  
  $(window).load(function(){
    $('.addtocartbtn').on('click', function(){
      $(this).children('span').text('Added, view cart');
      $(this).fadeOut(function(){
        $('.product-form__item--submit').append('<a class="btn btn--full" href="/cart">View Cart</a>');
        $('.site-header__cart-indicator').text(item_count+1);
      });

      $.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'json',
        success: function(data) { 
          var item_count = data.item_count;
          $('.site-header__cart-indicator').text(item_count);
        }
      });

    });
  });
  
});